module.exports = __webpack_public_path__ + "img/icon_19.e6963625.png";